import _classCallCheck from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/gg/mmp/Generali/20221219/generali/zuzahlungs-atlas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Input from './input';
import { INPUT_EVENT_TYPES } from '../constants';
import { window, userAgent, passiveSupported } from '../utils/globals';
var firefox = userAgent.indexOf('firefox') !== -1;
var WHEEL_EVENTS = INPUT_EVENT_TYPES.WHEEL_EVENTS;
var EVENT_TYPE = 'wheel';
// Constants for normalizing input delta
var WHEEL_DELTA_MAGIC_SCALER = 4.000244140625;
var WHEEL_DELTA_PER_LINE = 40;
// Slow down zoom if shift key is held for more precise zooming
var SHIFT_MULTIPLIER = 0.25;
var WheelInput = /*#__PURE__*/function (_Input) {
  _inherits(WheelInput, _Input);
  var _super = _createSuper(WheelInput);
  function WheelInput(element, callback, options) {
    var _this;
    _classCallCheck(this, WheelInput);
    _this = _super.call(this, element, callback, options);
    /* eslint-disable complexity, max-statements */
    _this.handleEvent = function (event) {
      if (!_this.options.enable) {
        return;
      }
      var value = event.deltaY;
      if (window.WheelEvent) {
        // Firefox doubles the values on retina screens...
        if (firefox && event.deltaMode === window.WheelEvent.DOM_DELTA_PIXEL) {
          value /= window.devicePixelRatio;
        }
        if (event.deltaMode === window.WheelEvent.DOM_DELTA_LINE) {
          value *= WHEEL_DELTA_PER_LINE;
        }
      }
      if (value !== 0 && value % WHEEL_DELTA_MAGIC_SCALER === 0) {
        // This one is definitely a mouse wheel event.
        // Normalize this value to match trackpad.
        value = Math.floor(value / WHEEL_DELTA_MAGIC_SCALER);
      }
      if (event.shiftKey && value) {
        value = value * SHIFT_MULTIPLIER;
      }
      _this.callback({
        type: EVENT_TYPE,
        center: {
          x: event.clientX,
          y: event.clientY
        },
        delta: -value,
        srcEvent: event,
        pointerType: 'mouse',
        target: event.target
      });
    };
    _this.events = (_this.options.events || []).concat(WHEEL_EVENTS);
    _this.events.forEach(function (event) {
      return element.addEventListener(event, _this.handleEvent, passiveSupported ? {
        passive: false
      } : false);
    });
    return _this;
  }
  _createClass(WheelInput, [{
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      this.events.forEach(function (event) {
        return _this2.element.removeEventListener(event, _this2.handleEvent);
      });
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */
  }, {
    key: "enableEventType",
    value: function enableEventType(eventType, enabled) {
      if (eventType === EVENT_TYPE) {
        this.options.enable = enabled;
      }
    }
  }]);
  return WheelInput;
}(Input);
export { WheelInput as default };